import { Directive, Input } from "@angular/core";

@Directive()
export abstract class ContextualSpeedingEditor<TItem extends { Id: number }> {
    @Input() selectedItem?: TItem;

    abstract save(): Promise<TItem>;
}